import "./Policies.css";
import Header from "../Shared/Header/Header";
import SubHeader from "../Shared/SubHeader/SubHeader";
import Footer from "../Shared/Footer/Footer";

const Policies = () => {
  return (
    <>
      <Header />
      <SubHeader title="RODO i Polityka Prywatności" 
        subtitle="Dbamy o najwyższy poziom bezpieczeństwa Twoich danych osobowych." 
      />
      <div className="terms-container policies">
        <h1>POLITYKA PRYWATNOŚCI i PRZETWARZANIA DANYCH OSOBOWYCH (RODO)</h1>
      
        <section>
          <main>Administratorem Państwa danych osobowych i właścicielem Serwisu www.synavie.pl jest Synavie Sp. z 
          o.o., zwane dalej Synavie, z siedzibą przy ul. Natolińskiej 3/24, 00-564 Warszawa, NIP: 7011252192, KRS: 
          0001163475. 
          </main>

          <main style={{'marginBottom':'10px'}}>
          Wchodząc na naszą stronę www.synavie.pl, wyrażacie Państwo zgodę na przetwarzanie danych osobowych 
          oraz oświadczacie, że zostaliście Państwo poinformowani o tym, że: 
          </main>
          <ol>
            <li>
              Synavie jest administratorem Państwa danych osobowych w rozumieniu ogólnego rozporządzenia 
              Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób 
              fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich 
              danych oraz uchylenia dyrektywy 95/46/WE (zwanego w dalszej części „RODO”). 
            </li>
            <li>
              We wszelkich sprawach związanych z przetwarzaniem Państwa danych osobowych należy kontaktować 
              się na adres: admin@synavie.pl. 
            </li>
            <li>
              Synavie przestrzega warunków określonych w przepisie art. 28 RODO, a w szczególności korzysta 
              wyłącznie z usług takich podmiotów przetwarzających, które zapewniają wystarczające gwarancje 
              wdrożenia odpowiednich środków technicznych i organizacyjnych, by przetwarzanie spełniało wymogi 
              niniejszego rozporządzenia i chroniło prawa osób, których dane dotyczą.  
            </li>
            <li>
              Synavie może przetwarzać dane osobowe przekazane przez inny podmiot wyłącznie w konkretnych, 
              wyraźnych i prawnie uzasadnionych celach i nie będzie przetwarzał ich dalej w sposób niezgodny z tymi 
              celami. 
            </li>
            <li>
              Synavie może przetwarzać następujące dane osobowe przekazane dobrowolnie przez Państwa: pliki 
              cookies, nick, imię, nazwisko, a w przypadku zgłoszenia się na diagnozę także PESEL, NIP, REGON, seria i 
              numer dokumentu tożsamości, data urodzenia, miejsce zamieszkania, nr telefonu, adres poczty 
              elektronicznej, imiona rodziców, miejsce urodzenia, posiadane wykształcenie, doświadczenie zawodowe, 
              numer rachunku bankowego, a także imię i nazwisko dziecka/dzieci oraz podane przez Państwa ich dane 
              osobowe. 
            </li>
            <li>
              Na podanych danych osobowych będą wykonywane następujące operacje: udostępnianie, modyfikowanie, 
              uzupełnianie, archiwizowanie, usuwanie.
            </li>
            <li>
              Przetwarzania danych będą dokonywać następujące kategorie osób:
              <ol type="a">
                  <li style={{'marginTop':'5px', 'marginBottom':'0px'}}>
                    pracownicy, zleceniobiorcy (m.in. psychologowie), współpracownicy, członkowie organów spółki, 
                    doradcy i konsultanci; 
                  </li>
                  <li style={{'marginTop':'5px', 'marginBottom':'0px'}}>
                    spółki i podmioty współpracujące, a także ich pracownicy i zleceniobiorcy (na podstawie odrębnych 
                    umów powierzenia przetwarzania danych osobowych). 
                  </li>
              </ol>
            </li>
            <li>
              Synavie jest zobowiązane do przestrzegania przepisów RODO oraz przepisów wykonawczych, a także 
              przepisów krajowych dotyczących ochrony danych osobowych.
            </li>
            <li>
              Synavie zobowiązuje się, przy przetwarzaniu powierzonych danych osobowych, do ich zabezpieczenia 
              poprzez stosowanie odpowiednich środków technicznych i organizacyjnych zapewniających adekwatny 
              stopień bezpieczeństwa odpowiadający ryzyku związanemu z przetwarzaniem danych osobowych, zgodnie z 
              art. 32 RODO. 
            </li>
            <li>
              Synavie oświadcza, że osoby upoważnione do przetwarzania danych osobowych zostały zapoznane z 
              przepisami o ochronie danych osobowych oraz z odpowiedzialnością za ich nieprzestrzeganie. Synavie 
              zobowiązuje się do ograniczenia dostępu do danych wyłącznie do osób, których dostęp do danych jest 
              potrzebny do realizacji umowy. 
            </li>
            <li>
              Przekazanie powierzonych danych do państwa trzeciego może nastąpić jedynie na pisemne polecenie
              wydane przez właściciela danych lub jeżeli będzie wynikało to z obowiązku określonego przepisami prawa. 
            </li>
            <li>
              Państwa dane osobowe przetwarzane będą w celach: nawiązania kontaktu oraz realizacji umowy na 
              świadczenie usług diagnostycznych, terapeutycznych oraz medycznych. 
            </li>
            <li>
              Podstawą przetwarzania Państwa danych osobowych jest zgoda, zawarta umowa oraz art. 6 ust. 1 lit. b) i 
              d) oraz art.9 ust. 2 lit. h) RODO, ustawa o działalności leczniczej, a także ustawa o ochronie zdrowia 
              psychicznego. 
            </li>
            <li>
              Podanie danych jest niezbędne do zawarcia i realizacji umowy oraz świadczenia usług. 
            </li>
            <li>
              Posiadają Państwo prawo do: żądania od Administratora dostępu do swoich danych osobowych, ich 
              sprostowania, usunięcia lub ograniczenia przetwarzania danych osobowych, wniesienia sprzeciwu wobec 
              takiego przetwarzania, przenoszenia danych, wniesienia skargi do organu nadzorczego tj. Prezesa Urzędu 
              Ochrony Danych Osobowych, cofnięcia zgody na przetwarzanie danych osobowych. W zakresie danych 
              przetwarzanych na podstawie przepisów prawa (np. dokumentacja medyczna) skorzystanie z prawa do 
              usunięcia danych może być ograniczone przez przepisy o obowiązkowym okresie przechowywania 
              dokumentacji. 
            </li>
            <li>
              Państwa dane osobowe nie podlegają zautomatyzowanemu podejmowaniu decyzji, w tym profilowaniu. 
            </li>
            <li>
              Pani/Pana dane osobowe będą przechowywane przez okres 20 lat. 
            </li>
            <li>
              Synavie po zakończeniu przetwarzania danych zobowiązany jest, zależnie od Państwa decyzji, do 
              niezwłocznego usunięcia lub zwrotu powierzonych mu danych, chyba że prawo Unii lub Rzeczypospolitej 
              Polskiej nakazuje przechowywanie danych osobowych.
            </li>
            <li>
              W celu zapewnienia, iż Polityka prywatności spełnia przez cały czas aktualne wymogi nałożone w 
              przepisach prawa, zastrzegamy sobie prawo do wnoszenia do niej zmian w dowolnym czasie. Powyższe ma 
              również zastosowanie w przypadkach, gdy Polityka prywatności wymaga zmian w celu objęcia nią nowych 
              lub zmienionych produktów lub usług Serwisu.
            </li>
          </ol>

        </section>
      </div>
      <Footer />
    </>
  );
};

export default Policies;